/**
 * @generated SignedSource<<5115ff33a71779ea2998875f4e37eb58>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type sidebarSelectorQuery$variables = {
  cloudId: string;
};
export type sidebarSelectorQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean | null | undefined;
      readonly leftSidebarWidth: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type sidebarSelectorQuery = {
  response: sidebarSelectorQuery$data;
  variables: sidebarSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "leftSidebarWidth"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "sidebarSelectorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sidebarSelectorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
    "metadata": {},
    "name": "sidebarSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "87261aab5010f6e217d4869107282805";

export default node;
